var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#030659"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3922 6.5H10.1307C8.12554 6.5 6.5 8.12554 6.5 10.1307V17.3922C6.5 19.3974 8.12554 21.0229 10.1307 21.0229H17.3922C19.3974 21.0229 21.0229 19.3974 21.0229 17.3922V10.1307C21.0229 8.12554 19.3974 6.5 17.3922 6.5Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6658 13.304C16.7554 13.9083 16.6522 14.5255 16.3708 15.0678C16.0894 15.6101 15.6442 16.0498 15.0985 16.3245C14.5528 16.5992 13.9344 16.6948 13.3312 16.5977C12.728 16.5007 12.1708 16.2159 11.7388 15.7839C11.3068 15.3519 11.022 14.7947 10.9249 14.1915C10.8279 13.5883 10.9235 12.9699 11.1981 12.4242C11.4728 11.8784 11.9126 11.4332 12.4549 11.1519C12.9971 10.8705 13.6143 10.7672 14.2187 10.8569C14.8351 10.9483 15.4058 11.2355 15.8465 11.6762C16.2871 12.1168 16.5744 12.6875 16.6658 13.304Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7549 9.76758H17.7622",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram2);
export default __webpack_public_path__ + "static/media/instagram-2.7125e31f6428f3415cec048f8e5a6aa3.svg";
export { ForwardRef as ReactComponent };